import React from 'react';
import { Button, Placeholder } from '@stitch-fix/mode-react';
import { useSelectEvent } from '@stitch-fix/event-reporter';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';
import ClickTooltip from '../shared/ClickTooltip';
import {
  allowClick,
  unselectedStateMessage,
} from '../../helpers/unselectedStateHelper';

const BuyNowButton = () => {
  const [state, dispatch] = useProductDetailsPageContext();
  const { reportSelectEvent } = useSelectEvent();

  const onBuyNowClick = () => {
    reportSelectEvent({
      schema: 'sku_select',
      name: 'buy_now',
      action_name: 'buy_now',
      sku_id: `${state.selectedSkuId}`,
    });

    dispatch({ type: 'BUY_NOW_CLICKED' });
  };

  if (state.loading || !state.shopProduct) {
    return <Placeholder height={4} />;
  }

  return allowClick(state) ? (
    <Button
      width="fill"
      variant="filled-staple"
      disabled={state.isSkuOutOfStock}
      onClick={onBuyNowClick}
      data-testid="buy-now-button"
    >
      {state.isSkuOutOfStock ? 'Out of stock' : 'Buy now'}
    </Button>
  ) : (
    <ClickTooltip
      text={unselectedStateMessage(state)}
      show={!allowClick(state) && state.ctaTooltipDisplay?.showBuyNow === true}
      arrowDirection="down"
    >
      <Button
        width="fill"
        variant="filled-staple"
        aria-label="warning"
        disabled={state.isSkuOutOfStock}
        onClick={() => {
          dispatch({
            type: 'DISABLED_BUY_NOW_CLICKED',
          });
        }}
        data-testid="buy-now-button-blocker"
      >
        {state.isSkuOutOfStock ? 'Out of stock' : 'Buy now'}
      </Button>
    </ClickTooltip>
  );
};

export default BuyNowButton;
